module.exports = __webpack_public_path__ + "static/image1-14dddce2d997a9b8298e750a3b30fc2b.jpg";